import { render, staticRenderFns } from "./QuestionForbidden.vue?vue&type=template&id=9251b96a&"
import script from "./QuestionForbidden.vue?vue&type=script&lang=js&"
export * from "./QuestionForbidden.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports